import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { MessageCircle, HelpCircle } from "lucide-react";
import { waLink } from "../lib/contact";

const FAQS = [
  {
    q: "Quanto tempo demora para a caçamba chegar em Jundiaí?",
    a: "Trabalhamos com entrega rápida. Em Jundiaí e bairros próximos, a entrega normalmente acontece no mesmo dia ou em até 24 horas, conforme disponibilidade. Para urgências, fale no WhatsApp e priorizamos seu atendimento.",
  },
  {
    q: "Quais tamanhos de caçamba a PJ Caçambas oferece?",
    a: "Disponibilizamos caçambas estacionárias nos tamanhos mais utilizados na construção civil (3m³ e 5m³), ideais para reformas residenciais, pequenas e médias obras. Consulte disponibilidade pelo WhatsApp.",
  },
  {
    q: "Posso colocar qualquer tipo de entulho na caçamba?",
    a: "A caçamba é destinada a entulho de construção civil — concreto, tijolo, madeira de obra, gesso, telhas, restos de reforma. Não é permitido descartar lixo orgânico, produtos químicos, baterias, lâmpadas ou material contaminado. Em caso de dúvida, consulte nossa equipe.",
  },
  {
    q: "Quantos dias posso ficar com a caçamba?",
    a: "O período padrão é flexível e combinado no momento do pedido. Caso precise de mais dias, basta avisar pelo WhatsApp. Trabalhamos com prazos justos e atendimento humano.",
  },
  {
    q: "Atendem empresas, construtoras e condomínios?",
    a: "Sim. Temos atendimento especializado para empresas, construtoras e condomínios, com possibilidade de planos contínuos, nota fiscal e logística programada. Solicite um plano sob medida pelo WhatsApp.",
  },
  {
    q: "Como funciona o pagamento?",
    a: "Aceitamos as principais formas de pagamento — Pix, dinheiro, cartão. As condições e valores são informados durante o orçamento, sempre com transparência e sem surpresas.",
  },
  {
    q: "O entulho é descartado de forma correta?",
    a: "Sim. A PJ Caçambas faz o descarte conforme normas ambientais, em locais licenciados. Cuidamos da destinação final do entulho com responsabilidade.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-16 md:py-24 bg-white"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#fff505] text-[#0f172a] text-xs font-extrabold uppercase tracking-[0.2em] mb-4 border-2 border-[#0f172a]">
            <HelpCircle className="w-3.5 h-3.5" strokeWidth={3} />
            Perguntas frequentes
          </div>
          <h2
            data-testid="faq-title"
            className="font-display text-4xl sm:text-5xl md:text-6xl text-[#0f172a]"
          >
            Tirando suas <span className="text-[#027ec3]">dúvidas</span>
          </h2>
          <p className="mt-4 text-[#475569] font-medium text-base md:text-lg max-w-2xl mx-auto">
            As respostas rápidas para quem quer alugar caçamba em Jundiaí sem
            burocracia.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-2 border-[#0f172a] bg-white px-5 md:px-6 data-[state=open]:bg-[#fff505]/30"
            >
              <AccordionTrigger className="font-extrabold text-[#0f172a] text-left text-base md:text-lg hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#475569] font-medium text-[15px] md:text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-10 text-center">
          <p className="text-[#475569] font-bold mb-4">Não achou sua dúvida?</p>
          <a
            href={waLink("Olá! Tenho uma dúvida sobre o aluguel de caçambas.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-whatsapp-btn"
            className="inline-flex items-center gap-3 px-6 py-4 bg-[#25d366] text-white font-extrabold uppercase tracking-wide border-2 border-[#0f172a] shadow-[6px_6px_0_#0f172a] hover:shadow-[10px_10px_0_#0f172a] hover:-translate-x-[3px] hover:-translate-y-[3px] transition-all"
          >
            <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
            Tirar dúvida no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default Faq;
